import browserUpdate from 'browser-update';

browserUpdate({
  required: { e: -3, f: -3, o: -3, s: -3, c: -3 },
  insecure: true,
  unsupported: true
})